"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportCompositePhotoOnly = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../../i18n");
const store_1 = require("../../../store");
const ImageWithTitle_1 = require("../components/ImageWithTitle");
const TitleBar_1 = require("../components/TitleBar");
const ReportHelpers_1 = require("../ReportHelpers");
const ReportBase_1 = require("./ReportBase");
class ReportCompositePhotoOnly extends ReportBase_1.ReportBase {
    constructor(poles) {
        super(poles);
    }
    buildPDF() {
        this.poles.forEach((pole, i) => {
            const job = store_1.AppStore.Tag.get(pole.jobId);
            pole.forEachField((field) => {
                // Truesize images
                if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                    const captures = field.getCaptures();
                    captures.forEach(capture => {
                        if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                            if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                const imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                // Title
                                this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, this.poles.length));
                                // Image
                                this.nodes.push(new ImageWithTitle_1.ImageWithTitle(field.schema.displayName, { reference: imageReferenceString }));
                            }
                        }
                    });
                }
            });
        });
    }
}
exports.ReportCompositePhotoOnly = ReportCompositePhotoOnly;
//# sourceMappingURL=ReportCompositePhotoOnly.js.map